import { InputField } from '@atoms/input';
import BlockBase from '@components/dnd/base/blockBase';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { useAtom } from '@hooks/useAtom';
import EndControlsFB, {
  type SettingsConfig
} from '@library/formBuilder/endControls';
import { type DNDBlock, ResolvedVariableType } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import { ParamsList } from '@/routes/routes.types';

import { initialDateFieldData } from './date.data';
import { DateModal } from './date.modal';
import { DateIcon } from './date.utils';

const DateField = (block: DNDBlock) => {
  const actionId = useParams()[ParamsList.ActionId] as string;

  const atom = useAtom({
    type: 'Date',
    sourceId: block.id,
    parentId: actionId,
    parentKind: 'form_action',
    initialData: initialDateFieldData,
    variableInfo: {
      resolvedType: ResolvedVariableType.Date
    }
  });

  if (!atom) {
    return null;
  }

  const getSettingsModal = (): SettingsConfig => ({
    title: atom.data.title || 'Date title',
    content: <DateModal atom={atom} />
  });

  const getEndControls = () => (
    <EndControlsFB
      dataItem={atom}
      dndBlock={block}
      hasRequired
      settings={getSettingsModal()}
    />
  );

  return (
    <BlockBase
      dataItem={atom}
      dndBlock={block}
      endControls={getEndControls()}
      icon={DateIcon}
      title={atom.data.title}
    >
      <Column>
        <InputField
          label="Field title"
          onChange={e => {
            atom.data.title = e.target.value;
          }}
          placeholder="Aa"
          required
          value={atom.data.title}
        />
      </Column>
    </BlockBase>
  );
};

export default observer(DateField);
